import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createEvent, type CreateEventOptions } from '~/client/event/events'

export const useCreateEvent = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['createEvent'],
    mutationFn: (options: CreateEventOptions) => createEvent(options),
    onSuccess: ({ event }) => {
      queryClient.invalidateQueries({ queryKey: ['events'] })
      if (event?.id) {
        queryClient.invalidateQueries({ queryKey: ['event', String(event.id)] })
      }
    },
  })
}
